import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData } from "../../../../serverRequest";
import LoadingSpinner from "../../../../components/Loadder";
import moment from 'moment';
import ProductWarrantyListTable from "../../../../components/Tables/ProductWarrantyListTable";
import SubscriptionListTable from "../../../../components/Tables/SubscriptionListTable";
import { Link } from 'react-router-dom';

export default function SubscriptionList() {
    const [open, setOpen] = React.useState(true);
    const [totalSubscriptions, setTotalSubscriptions] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    
    const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    };
  
    const filterSubscriptionData = (subscriptions_data) => {
      let totalSubscription = [];
      if(subscriptions_data){
        for (let i = 0; i < subscriptions_data.length; i++) {
            totalSubscription.push(subscriptions_data[i])
        }
      }
     
      setTotalSubscriptions(totalSubscription);
      return ({ "total": totalSubscription})
    }
    React.useEffect(() => {
      async function fetchData() {
        let resData = await getData('/api/inventory/subscription/')
        let subscription_data = resData['data']['subscription_data']
        console.log(subscription_data);
        let subscriptionData = await filterSubscriptionData(subscription_data)
  
       
        setLoading(false);
      }
      fetchData();
  
  
    }, [])
    return (
        <>

            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    <div className="rounded-t bg-white mb-0 px-6 py-6">
                        <div className="text-center flex justify-between">
                            <h6 className="text-blueGray-700 text-xl font-bold">Subscriptions</h6>
                            <Link to="/admin/inventory/subscriptionForm">
                            <button
                                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Subscription
                            </button>
                            </Link>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingSpinner></LoadingSpinner>
                    ) : (<>
                        <div
                            className={
                                "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                                ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                            }
                        >

                            <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                                {/* Projects table */}
                                <SubscriptionListTable totalSubscriptions={totalSubscriptions}></SubscriptionListTable>

                            </div>
                        </div>
                    </>)}
                </div>
            </main>

        </>
    );
}
